import React, { Fragment } from "react";

const tabLabelDesktop = (props) => {
  return(
    <label className="triggerLabel" htmlFor={props.checkboxId}>
      <i className={`materialIcon _off ${props.labelIconClass}`}>{props.labelIconTextOff}</i>
      <i className={`materialIcon _on ${props.labelIconClass}`}>{props.labelIconTextOn}</i>
      {props.labelText}
    </label>
  )
}

const tabLabelMobile = (props) => {
  return(
    <label className="triggerLabel" htmlFor={props.checkboxId}>
      <i className="materialIcon _off">{props.labelIconText} </i>
      <i className="materialIcon _on">{props.labelIconTextON}</i>
     {props.labelText ? <small>{props.labelText}</small> : ''}
    </label>
  )
}

const ulTag = (props) => {
  return(
    <ul>
      {props.liItems.map( item => item )}
    </ul>
  )
}

const SlidingComponent = (props) => {
  return (
    <Fragment>
      <input
        type="checkbox"
        className={props.checkboxClass}
        id={props.checkboxId}
        checked={props.open}
        onChange={props.setOpen}
        onClick={props.onClick}
        data-testid={props.dataTestId}
      />
      {props.mobileView ? tabLabelMobile(props) : tabLabelDesktop(props)}
      { props.open ? ulTag(props) : "" }
    </Fragment>
  )
}

export default SlidingComponent;



// WEBPACK FOOTER //
// ./src/features/shared/components/misc/SlidingComponent.js